import React from 'react';
import { EyeOff } from 'lucide-react';
export function MirrorSection() {
  return <section className="py-12 px-6 md:px-12 lg:px-16 bg-deep-black border-t border-card-border relative overflow-hidden" data-id="element-219">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-220">
        {/* Left: Image Placeholder */}
        

        {/* Right: Copy */}
        <div className="flex flex-col justify-center" data-id="element-221">
          <h2 className="font-bebas text-4xl md:text-5xl text-white mb-6 leading-tight" data-id="element-222">
            ¿Cansado de borrar el{' '}
            <span className="border-b-4 border-cyan-neon pb-1" data-id="element-223">historial?</span>
          </h2>

          <div className="space-y-6 font-inter text-base md:text-lg text-text-muted leading-relaxed" data-id="element-224">
            <p data-id="element-225">
              Nadie sospecha de ti. Todos ven al hombre fuerte, al líder, al
              trabajador excepcional. Pero a medianoche, cuando el laptop se
              abre... te conviertes en un extraño.
            </p>
            <p data-id="element-226">
              La culpa te drena la testosterona, la niebla mental te roba tu
              enfoque y cada 'promesa rota' te quita un pedazo de tu hombría.
            </p>
            <p className="text-white font-semibold text-xl border-l-4 border-alert-red pl-4 py-1" data-id="element-227">
              ¿Hasta cuándo vas a seguir gestionando tu vergüenza en lugar de
              blindar tu vida?
            </p>
          </div>
        </div>
      </div>
    </section>;
}